/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// Use full path with a domain for static resources
// This is needed to resolve pathes of dynamic imports
// @ts-ignore 'WebpackConfig.ts' cannot be compiled under '--isolatedModules' because it is considered a global script file. Add an import, export, or an empty 'export {}' statement to make it a module.
declare let __webpack_public_path__: string;
if (process.env.BUILD_TOOL !== 'vite') {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  __webpack_public_path__ = `${window.__ENV_CONFIG__.staticBaseUrl}`;
}
